import script from "./ItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemCard.vue?vue&type=script&setup=true&lang=js"

import "./ItemCard.vue?vue&type=style&index=0&id=bfda24f2&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfda24f2"]])

export default __exports__